import { render, staticRenderFns } from "./contact-request-force-assign-dialog.vue?vue&type=template&id=ee36ad6e&scoped=true&"
import script from "./contact-request-force-assign-dialog.vue?vue&type=script&lang=js&"
export * from "./contact-request-force-assign-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee36ad6e",
  null
  
)

export default component.exports